// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavigationAfterLogin-root-Ip3mq {
	margin: 0;
}

.NavigationAfterLogin-navDropDown-VPG2P {
	border: 0px;
}

.NavigationAfterLogin-userAvatar-YVV53 {
	height: 30px;
	width: 30px;
	border-radius: 50%;
	border: 2px solid var(--primary-border);
}

.NavigationAfterLogin-breakPointScreen-VzO8z {
	display: none !important;
}

.NavigationAfterLogin-nonBreakPointScreen-AmKAJ {
	display: block !important;
}

.NavigationAfterLogin-innerLink-Sv3wJ a {
	color: var(--primary-foreground) !important;
	font-size: 16px;
	text-decoration: none !important;
}

.NavigationAfterLogin-floatLeft-VUFD1 {
	float: left;
}

.NavigationAfterLogin-disPlayInline-TXlNz {
	display: inline-block;
}

.NavigationAfterLogin-innerLink-Sv3wJ {
	margin-right: 15px;
	position: relative;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 130px;
}

.NavigationAfterLogin-centerLink-wAtVO {
	display: inline-block;
	font-size: 18px;
	color: var(--common-primary-white-foreground);
	margin-right: 50px;
	font-weight: 600;
}

.NavigationAfterLogin-centerLink-wAtVO:last-child {
	margin: 0;
}

.NavigationAfterLogin-centerLink-wAtVO a,
.NavigationAfterLogin-centerLink-wAtVO a:hover,
.NavigationAfterLogin-centerLink-wAtVO a:focus {
	color: var(--primary-color);
	text-decoration: none;
}

.NavigationAfterLogin-dot-uzlvT {
	position: relative;
}

.NavigationAfterLogin-dot-uzlvT::after {
	content: '';
	width: 6px;
	height: 6px;
	background: var(--common-primary-white-foreground);
	border-radius: 50%;
	position: absolute;
	top: 48%;
	right: -26px;
}

.NavigationAfterLogin-dot-uzlvT::before {
	content: '';
	width: 57px;
	height: 1.5px;
	background: var(--common-primary-white-foreground);
	position: absolute;
	bottom: -3px;
	right: 0;
	left: 0;
	margin: 0 auto;
}

.NavigationAfterLogin-menuDivider-cebAH {
	border-top: 1px solid var(--primary-border);
	padding-bottom: 20px;
}

.NavigationAfterLogin-menuDividerMobile-GOaSD {
	border-top: 1px solid var(--primary-border);

}

.NavigationAfterLogin-themeIcon-qMwkP {
	margin: 0 8px;
}

.NavigationAfterLogin-themeIconSec-PiNx_ {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	font-size: 16px;
	gap: 4px;
}

.NavigationAfterLogin-themeIconAlignment-UCZMS {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.NavigationAfterLogin-selectedThemeColor-NKlec {
	color: var(--secondary-bg);
}

.NavigationAfterLogin-linkColor-Xluuo {
	color: var(--primary-foreground);
}

.NavigationAfterLogin-dFlex-NH8lw {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.NavigationAfterLogin-mh10-ZJ9I4 {
	margin: 0 10px 0 10px;
}

.nav li a:hover {
	background: transparent !important;
}

.NavigationAfterLogin-divider-evgFN {
	width: 2px;
	height: 30px;
	background: #fff;
	display: inline-block;
	margin: 0 16px;
}

@media screen and (max-width: 1199px) {
	.NavigationAfterLogin-breakPointScreen-VzO8z {
		display: block !important;
	}

	.NavigationAfterLogin-nonBreakPointScreen-AmKAJ {
		display: none !important;
	}

	.NavigationAfterLogin-newMenu-q1bcX {
		height: 100vh;
		background: #fff !important;
		overflow-y: scroll;
	}

	.NavigationAfterLogin-newMenuDesign-pC21X {
		margin-top: 20px;
		border-top: 1px solid var(--border-secondary-color);
	}

	.NavigationAfterLogin-newMenuDesign-pC21X {
		margin-top: 50px;
		border-top: 1px solid var(--primary-border);
		background-color: var(--background-primary);
	}

	.NavigationAfterLogin-menuDivider-cebAH {
		padding-bottom: 0px;
	}
}

@media screen and (min-width: 768px) {
	.NavigationAfterLogin-paddingDropDown-_cm7v {
		padding-right: 0px !important;
		margin-left: 5px;
	}
}

@media screen and (max-width: 1199px) {
	.NavigationAfterLogin-tabViewHidden-Z9ene {
		display: none !important;
	}
}

@media screen and (max-width:1199px) and (min-width:768px) {
	.NavigationAfterLogin-newMenu-q1bcX {
		left: 0;
	}

	.NavigationAfterLogin-newMenuDesign-pC21X {
		margin-top: 60px !important;
		border-top: 1px solid var(--border-secondary-color);
		margin-right: 0px !important;
	}
}

@media screen and (max-width:767px) {
	.NavigationAfterLogin-newMenuDesign-pC21X {
		margin-top: 60px;
	}

	.NavigationAfterLogin-mbTop-lqf0i a {
		padding-top: 8px !important;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/NavigationAfterLogin/NavigationAfterLogin.css"],"names":[],"mappings":"AAAA;CACC,SAAS;AACV;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,2CAA2C;CAC3C,eAAe;CACf,gCAAgC;AACjC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;CAEhB,uBAAuB;CACvB,YAAY;AACb;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,6CAA6C;CAC7C,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,SAAS;AACV;;AAEA;;;CAGC,2BAA2B;CAC3B,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,UAAU;CACV,WAAW;CACX,kDAAkD;CAClD,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;CACR,YAAY;AACb;;AAEA;CACC,WAAW;CACX,WAAW;CACX,aAAa;CACb,kDAAkD;CAClD,kBAAkB;CAClB,YAAY;CACZ,QAAQ;CACR,OAAO;CACP,cAAc;AACf;;AAEA;CACC,2CAA2C;CAC3C,oBAAoB;AACrB;;AAEA;CACC,2CAA2C;;AAE5C;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,eAAe;CACf,QAAQ;AACT;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;;AAGA;CACC,kCAAkC;AACnC;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,gBAAgB;CAChB,qBAAqB;CACrB,cAAc;AACf;;AAGA;CACC;EACC,yBAAyB;CAC1B;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;CACnB;;CAEA;EACC,gBAAgB;EAChB,mDAAmD;CACpD;;CAEA;EACC,gBAAgB;EAChB,2CAA2C;EAC3C,2CAA2C;CAC5C;;CAEA;EACC,mBAAmB;CACpB;AACD;;AAGA;CACC;EACC,6BAA6B;EAC7B,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,wBAAwB;CACzB;AACD;;AAEA;CACC;EACC,OAAO;CACR;;CAEA;EACC,2BAA2B;EAC3B,mDAAmD;EACnD,4BAA4B;CAC7B;AACD;;AAEA;CACC;EACC,gBAAgB;CACjB;;CAEA;EACC,2BAA2B;CAC5B;AACD","sourcesContent":[".root {\n\tmargin: 0;\n}\n\n.navDropDown {\n\tborder: 0px;\n}\n\n.userAvatar {\n\theight: 30px;\n\twidth: 30px;\n\tborder-radius: 50%;\n\tborder: 2px solid var(--primary-border);\n}\n\n.breakPointScreen {\n\tdisplay: none !important;\n}\n\n.nonBreakPointScreen {\n\tdisplay: block !important;\n}\n\n.innerLink a {\n\tcolor: var(--primary-foreground) !important;\n\tfont-size: 16px;\n\ttext-decoration: none !important;\n}\n\n.floatLeft {\n\tfloat: left;\n}\n\n.disPlayInline {\n\tdisplay: inline-block;\n}\n\n.innerLink {\n\tmargin-right: 15px;\n\tposition: relative;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\t-o-text-overflow: ellipsis;\n\ttext-overflow: ellipsis;\n\twidth: 130px;\n}\n\n.centerLink {\n\tdisplay: inline-block;\n\tfont-size: 18px;\n\tcolor: var(--common-primary-white-foreground);\n\tmargin-right: 50px;\n\tfont-weight: 600;\n}\n\n.centerLink:last-child {\n\tmargin: 0;\n}\n\n.centerLink a,\n.centerLink a:hover,\n.centerLink a:focus {\n\tcolor: var(--primary-color);\n\ttext-decoration: none;\n}\n\n.dot {\n\tposition: relative;\n}\n\n.dot::after {\n\tcontent: '';\n\twidth: 6px;\n\theight: 6px;\n\tbackground: var(--common-primary-white-foreground);\n\tborder-radius: 50%;\n\tposition: absolute;\n\ttop: 48%;\n\tright: -26px;\n}\n\n.dot::before {\n\tcontent: '';\n\twidth: 57px;\n\theight: 1.5px;\n\tbackground: var(--common-primary-white-foreground);\n\tposition: absolute;\n\tbottom: -3px;\n\tright: 0;\n\tleft: 0;\n\tmargin: 0 auto;\n}\n\n.menuDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tpadding-bottom: 20px;\n}\n\n.menuDividerMobile {\n\tborder-top: 1px solid var(--primary-border);\n\n}\n\n.themeIcon {\n\tmargin: 0 8px;\n}\n\n.themeIconSec {\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: 16px;\n\tgap: 4px;\n}\n\n.themeIconAlignment {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.selectedThemeColor {\n\tcolor: var(--secondary-bg);\n}\n\n.linkColor {\n\tcolor: var(--primary-foreground);\n}\n\n.dFlex {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.mh10 {\n\tmargin: 0 10px 0 10px;\n}\n\n\n:global(.nav) li a:hover {\n\tbackground: transparent !important;\n}\n\n.divider {\n\twidth: 2px;\n\theight: 30px;\n\tbackground: #fff;\n\tdisplay: inline-block;\n\tmargin: 0 16px;\n}\n\n\n@media screen and (max-width: 1199px) {\n\t.breakPointScreen {\n\t\tdisplay: block !important;\n\t}\n\n\t.nonBreakPointScreen {\n\t\tdisplay: none !important;\n\t}\n\n\t.newMenu {\n\t\theight: 100vh;\n\t\tbackground: #fff !important;\n\t\toverflow-y: scroll;\n\t}\n\n\t.newMenuDesign {\n\t\tmargin-top: 20px;\n\t\tborder-top: 1px solid var(--border-secondary-color);\n\t}\n\n\t.newMenuDesign {\n\t\tmargin-top: 50px;\n\t\tborder-top: 1px solid var(--primary-border);\n\t\tbackground-color: var(--background-primary);\n\t}\n\n\t.menuDivider {\n\t\tpadding-bottom: 0px;\n\t}\n}\n\n\n@media screen and (min-width: 768px) {\n\t.paddingDropDown {\n\t\tpadding-right: 0px !important;\n\t\tmargin-left: 5px;\n\t}\n}\n\n@media screen and (max-width: 1199px) {\n\t.tabViewHidden {\n\t\tdisplay: none !important;\n\t}\n}\n\n@media screen and (max-width:1199px) and (min-width:768px) {\n\t.newMenu {\n\t\tleft: 0;\n\t}\n\n\t.newMenuDesign {\n\t\tmargin-top: 60px !important;\n\t\tborder-top: 1px solid var(--border-secondary-color);\n\t\tmargin-right: 0px !important;\n\t}\n}\n\n@media screen and (max-width:767px) {\n\t.newMenuDesign {\n\t\tmargin-top: 60px;\n\t}\n\n\t.mbTop a {\n\t\tpadding-top: 8px !important;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `NavigationAfterLogin-root-Ip3mq`,
	"navDropDown": `NavigationAfterLogin-navDropDown-VPG2P`,
	"userAvatar": `NavigationAfterLogin-userAvatar-YVV53`,
	"breakPointScreen": `NavigationAfterLogin-breakPointScreen-VzO8z`,
	"nonBreakPointScreen": `NavigationAfterLogin-nonBreakPointScreen-AmKAJ`,
	"innerLink": `NavigationAfterLogin-innerLink-Sv3wJ`,
	"floatLeft": `NavigationAfterLogin-floatLeft-VUFD1`,
	"disPlayInline": `NavigationAfterLogin-disPlayInline-TXlNz`,
	"centerLink": `NavigationAfterLogin-centerLink-wAtVO`,
	"dot": `NavigationAfterLogin-dot-uzlvT`,
	"menuDivider": `NavigationAfterLogin-menuDivider-cebAH`,
	"menuDividerMobile": `NavigationAfterLogin-menuDividerMobile-GOaSD`,
	"themeIcon": `NavigationAfterLogin-themeIcon-qMwkP`,
	"themeIconSec": `NavigationAfterLogin-themeIconSec-PiNx_`,
	"themeIconAlignment": `NavigationAfterLogin-themeIconAlignment-UCZMS`,
	"selectedThemeColor": `NavigationAfterLogin-selectedThemeColor-NKlec`,
	"linkColor": `NavigationAfterLogin-linkColor-Xluuo`,
	"dFlex": `NavigationAfterLogin-dFlex-NH8lw`,
	"mh10": `NavigationAfterLogin-mh10-ZJ9I4`,
	"divider": `NavigationAfterLogin-divider-evgFN`,
	"newMenu": `NavigationAfterLogin-newMenu-q1bcX`,
	"newMenuDesign": `NavigationAfterLogin-newMenuDesign-pC21X`,
	"paddingDropDown": `NavigationAfterLogin-paddingDropDown-_cm7v`,
	"tabViewHidden": `NavigationAfterLogin-tabViewHidden-Z9ene`,
	"mbTop": `NavigationAfterLogin-mbTop-lqf0i`
};
module.exports = ___CSS_LOADER_EXPORT___;
